import { mapState, mapActions, mapGetters } from "vuex";
import AppIcon from "@/components/AppIcon";
import ChevronDownIcon from "@/components/icons/ChevronDownIcon.vue";
import ChevronRightIcon from "@/components/icons/ChevronRightIcon.vue";
import AppPopover from "@/components/AppPopover";
import LoadingElement from "@/components/shared/LoadingElement.vue";
import BrandPortfolioMixin from "@/mixins/BrandPortfolioMixin.vue";
export default {
  name: "BrandPortfolioWorkspaceNameCell",
  components: {
    AppIcon,
    ChevronDownIcon,
    ChevronRightIcon,
    AppPopover,
    LoadingElement
  },
  mixins: [BrandPortfolioMixin],
  emits: ["onWorkspaceNameClickHandler", "onWorkspaceAlertClickHandler"],
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    portfolio: {
      type: Object,
      default: {}
    }
  },
  computed: {
    ...mapState({
      accounts: state => state.account.list,
      workspaces: state => state.workspace.list
    })
  },
  methods: {
    workspaceNameForBrandPortfolio(workspace_id) {
      return this.workspaces.find(workspace => workspace.workspace_id == workspace_id)?.workspace_name ?? "-";
    },
    formatAlertCount(count) {
      return count > 99 ? "+99" : count;
    },
    onWorkspaceNameClickHandler(workspace_id) {
      this.$emit("onWorkspaceNameClickHandler", workspace_id);
    },
    onWorkspaceAlertClickHandler(workspace_id) {
      this.$emit("onWorkspaceAlertClickHandler", workspace_id);
    }
  }
};